<mat-card >
    <mat-card-header class="titreFrm">
    <mat-card-title>BULLETIN DE NOTES</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
  <!-------------------- bouton -->
        <div class="btn">
            <div class="button-row">
              <button [disabled]="buttonDisabled"  (click)="afficherBulletinNote(noteApprenants)" mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Afficher</button>
            </div>
        </div>
        <mat-card>
            <mat-card-content>
                <app-avt-listes #listeAppenantsComponen [heightTable]="'400'" [dataSourceBrut]="dataSourceAppenants" [displayedColumnsBrut]="columnsAppenants"></app-avt-listes>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>

<ng-template #noteApprenants>
    <mat-card >
        <mat-card-header class="titreFrm">
            <mat-card-title>Evaluations de l’apprenant {{apprenant.toUpperCase()}}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="border">
            <mat-tab-group #tabGroupe >
                <!-------------------- Notes ------------>
                <mat-tab label="Notes">
                    <app-avt-listes #listeNoteComponen [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsNote" ></app-avt-listes>
                </mat-tab>
                <!-------------------- Appréciation par matière ------------>
                <mat-tab label="Appréciation par matière">
                    <app-avt-listes #listeAppreciationMatiereComponen [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsAppreciation" ></app-avt-listes>
                </mat-tab>
                <!-------------------- Appréciation par période ------------>
                <mat-tab label="Appréciation par période">
                    <div class="btn">
                        <div class="button-row">
                        <button [disabled]="buttonDisabled"  mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Détails période</button>
                        </div>
                    </div>
                    <app-avt-listes #listeAppreciationPeriodeComponen [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsAppreciation" ></app-avt-listes>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</ng-template>